const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogPerfil(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogPerfil`, params);
    },
    $obterRelatorioLogCSVPerfil(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogPerfilCsv`, params);
    },
    $obterRelatorioLogPDFPerfil(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogPerfilPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
